export default {
  numbers: 'neg',
  operations: 'add',
  negative: true,
  generate () {
    // create questions if needed
  },
  getQuestion (answerCount) {
    const targetNumber = Math.floor(Math.random() * 50) + 1
    const num = Math.floor(Math.random() * 50) + 1
    const negNum = Math.min(num, targetNumber) - Math.max(num, targetNumber) // negative
    let oper = this.operations
    if (oper === 'mixed') {
      const op = Math.round(Math.random())
      if (op) {
        oper = 'add'
      } else {
        oper = 'subtract'
      }
    }

    let sen = ''
    let answers = []

    if (oper === 'add') {
      answers.push({ answer: Math.min(num, targetNumber), correct: true })
      sen += negNum + ' + ' + Math.max(num, targetNumber)

      if (answerCount > 1) {
        let wrongAnswers = []
        for (let i = 0; i < Math.max(targetNumber, num); i++) {
          if (i !== Math.min(num, targetNumber)) {
            wrongAnswers.push(i)
          }
        }
        wrongAnswers = this.shuffleArray(wrongAnswers)
        for (let j = 0; j < answerCount - 1; j++) {
          answers.push({ answer: '' + wrongAnswers[j], correct: false })
        }
        answers = this.shuffleArray(answers)
      }
      return { question: sen, answers }
    } else { // take away
      answers.push({ answer: negNum, correct: true })
      sen = Math.min(num, targetNumber) + ' - ' + Math.max(num, targetNumber)
      // wrong answers
      if (answerCount > 1) {
        let wrongAnswers = []
        for (let i = 0; i <= Math.max(num, targetNumber); i++) {
          if (-i !== negNum) {
            wrongAnswers.push((-i))
          }
        }
        wrongAnswers = this.shuffleArray(wrongAnswers)
        for (let j = 0; j < answerCount - 1; j++) {
          answers.push({ answer: '' + wrongAnswers[j], correct: false })
        }
        answers = this.shuffleArray(answers)
      }
      return { question: sen, answers }
    }
  },
  shuffleArray (array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      const temp = array[i]
      array[i] = array[j]
      array[j] = temp
    }
    return array
  }
}
